import {
    Box, Divider, Drawer, List, ListItem, ListItemIcon, ListItemText,
} from '@mui/material';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { useHistory } from 'react-router-dom';
import { useFetchJsonFile } from '../../hooks';
import { menuIcons } from '../../utils/constants';
import { SideMenuItems } from './NavigationUtils';

type Props = {
    open: boolean;
    handleToggle:(toggle?:boolean)=>void;
};
const MenuDrawer = (props: Props) => {
    const { open, handleToggle } = props;
    const menulist = useFetchJsonFile({ path: '/SideMenu.json' }) as {
        data: {
        sideMenuItems:SideMenuItems[]
        }
    };
    const history = useHistory();
    const handleMenuItemClick = (menuItem:SideMenuItems) => {
        console.log('menuItem: ', menuItem);
        history.push(menuItem.route);
    };

    const drawerWidth = 250;

    const getListItems = (menuItem: SideMenuItems) => {
        const SideIcon = menuIcons[menuItem.icon as keyof typeof menuIcons];
        const active = history.location.pathname === menuItem.route;

        return ((
            <>
                <ListItem
                    key={menuItem.title}
                    onClick={() => handleMenuItemClick(menuItem)}
                    sx={(theme) => ({
                        border: `${active ? `1px solid ${theme.palette.primary.main}` : 'none'}`,
                        borderRadius: '10px',
                        cursor: 'pointer',
                        marginBottom: '5px',
                        marginTop: '5px',
                    })}
                >
                    <ListItemIcon>
                        {
                            menuItem.icon ? (
                                <SideIcon
                                    sx={(theme) => ({
                                        color: `${active ?
                                            theme.palette.primary.main :
                                            '#727374'}`,
                                    })}
                                />
                            ) : (
                                <HorizontalRuleIcon
                                    sx={(theme) => ({
                                        color: `${active ?
                                            theme.palette.primary.main :
                                            '#727374'}`,
                                    })}
                                />
                            )
                        }
                    </ListItemIcon>
                    <ListItemText
                        sx={(theme) => ({
                            color: `${active ?
                                theme.palette.primary.main :
                                '#727374'}`,
                            fontWeight: 'bolder!important',
                        })}
                        primary={open ? menuItem.title : ''}
                    />
                </ListItem>
                <Divider />
            </>
        )

        );
    };

    return (
        <Drawer
            onMouseEnter={() => {
                console.log('MouseEnter');
                handleToggle(true);
            }}
            onMouseLeave={() => handleToggle()}
            anchor="left"
            open={open}
            onClose={() => handleToggle()}
            variant="permanent"
            sx={{
                padding: '4px',
                width: open ? drawerWidth : 78,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: open ? drawerWidth : 78,
                    boxSizing: 'border-box',
                    transition: 'width 0.4s ease-in-out',
                },
                '& .MuiListItem-root': {
                    height: 56,
                },
                '& .MuiListItemIcon-root': {
                    minWidth: 40,
                    transition: 'min-width 0.3s  ease-in-out',
                },
                '& .MuiSvgIcon-root': {
                    fontSize: 24,
                },
            }}
        >
            <Box sx={{ overflow: 'auto', overflowX: 'hidden' }} p={1} pt={7}>
                <List>
                    {
                        (menulist?.data?.sideMenuItems)?.map((
                            item: SideMenuItems,
                        ) => getListItems(item))
                    }
                </List>
            </Box>
        </Drawer>
    );
};

export default MenuDrawer;
